/* eslint-disable max-len */
import { DatePicker } from 'antd'
import React, {useRef} from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux';
import 'moment/locale/en-gb'; // Import the desired locale (e.g., English - United Kingdom)
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
dayjs.extend(customParseFormat);


export default function DateRange({handleSelectObject, setSelectedDates,didSubDropdownChange, selectedDates, searchParams, FilterCheckbox ,dateErrorMsg,dateError, setdateError,handleCheck, isDateRangeSelected}) {
    const urlParams = new URLSearchParams(window.location.search);
    const {dateObject}=useSelector(state=>state.BranchSlice); 
    const {start_date,end_date}=dateObject
   
    return (
        <div class="mt-2 w-[82%]">
            <div class="w-full">
                <label htmlFor="startdate" class="w-full text-sm font-medium text-[#344054] pb-1.5">Start Date</label>
                <div class="relative w-full">
                    <DatePicker
                        className='cursor-pointer custom-datepicker slct-inpt-fld'
                        id='start_date'
                        format="MMM DD, YYYY" 
                        placeholder='Select Start Date'
                        onChange={(date,dateString,id) => {
                            if(isDateRangeSelected === false){
                                handleSelectObject('start_date',dateString,); 
                                setSelectedDates((prv)=>({
                                    ...prv,
                                    ["start_date"]:  date
                                }))
                            }
                        }} 
                        value={!didSubDropdownChange && searchParams.get('dropname') === 'Custom' ? dayjs(FilterCheckbox?.start_date) :  searchParams.get('start_date') === null ? selectedDates?.start_date === '' ?  ''  : selectedDates?.start_date : selectedDates?.start_date === '' ?  ''  : selectedDates?.start_date }
                        allowClear={false}  
                        defaultValue={null}
                        onFocus={()=>setdateError(false)}
                        suffixIcon={<img src="/images/calendar.svg" alt="icon" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-[-20px] w-[20px]"/>}
                    />
                </div>
            </div>
            <div class="w-full mt-2">
                <label htmlFor="enddate" class="w-full text-sm font-medium text-[#344054] pb-1.5">End Date</label>
                <div class="relative w-full">
                    <DatePicker
                        className='cursor-pointer custom-datepicker slct-inpt-fld'
                        id='end_date'
                        format="MMM DD, YYYY"
                        showToday={false}
                        onFocus={()=>setdateError(false)}
                        placeholder='Select End Date'
                        onChange={(date,dateString,id) => { 
                            if(isDateRangeSelected === false){
                                handleSelectObject('end_date',dateString,
                                    setSelectedDates((prv)=>({
                                        ...prv,
                                        ["end_date"]:  date
                                    }))
                                )
                            }
                        }} 
                        value={!didSubDropdownChange && searchParams.get('dropname') === 'Custom' ? dayjs(FilterCheckbox?.end_date) :  searchParams.get('end_date') === null ? selectedDates?.end_date === '' ?  ''  : selectedDates?.end_date : selectedDates?.end_date === '' ?  ''  : selectedDates?.end_date }
                        defaultValue={null}
                        allowClear={false}
                        suffixIcon={<img src="/images/calendar.svg" alt="icon" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-[-20px] w-[20px]"/>}
                    />
                </div>
                {dateError &&<p class="text-xs text-red-500 mt-2 w-[165px]">{dateErrorMsg}</p>}
            </div>
            {/* {dateErrorMessage && <p class="text-xs text-red-500 mt-2">{'Please select the valid date range.'}</p>}
            <div class="flex items-center mt-5 justify-between">
                <button onClick={() => handleApplyFiilter('clear')} type="button" class="px-3.5 py-2 border border-[#106EB4] rounded-lg">
                    <span class="text-f2 font-semibold text-[#106EB4]">Clear</span>
                </button>
                <button onClick={() => handleApplyFiilter('apply')} type="button" class="px-3.5 py-2 bg-[#106EB4] text-white rounded-lg">
                    <span class="text-f2 font-semibold text-[#ffffff]">Apply Filter</span>
                </button>
            </div> */}
        </div>
    )
}
